import { ReactComponent as BrandDefenseFilledSmall } from '../assets/brand-defense-filled-small.svg';
import { ReactComponent as CategoryReviewFilledSmall } from '../assets/category-review-filled-small.svg';
import { ReactComponent as WhosMyShopperFilledSmall } from '../assets/whos-my-shopper-filled-small.svg';

/**
 * gets survey icon based on route
 * @param  {String} fastTrackRoute
 * @return {Node}   react component
 */
export const getFastTrackIcon = (fastTrackRoute) => {
  const baseRoutePath = '/dashboard/narrative';

  switch (fastTrackRoute) {
    case `${baseRoutePath}/brand-defense`:
      return <BrandDefenseFilledSmall />;
    case `${baseRoutePath}/category-review`:
      return <CategoryReviewFilledSmall />;
    case `${baseRoutePath}/who-is-my-shopper`:
      return <WhosMyShopperFilledSmall />;
    default:
      return '';
  }
};
